<template>
    <div>
        <UiHeroCardLayoutHeader
            v-editable="blok"
            :blok="blok"
            class="ui-hero-card-layout-header"
            :style="layoutHeaderStyles"
        ></UiHeroCardLayoutHeader>
    </div>
</template>

<script setup lang="ts">
import type { IHeroCardLayoutHeader } from '@nuxt-monorepo/ui/types/components/HeroCardLayout/LayoutHeader';

const { blok } = defineProps<{ blok: IHeroCardLayoutHeader }>();

const img = useImage();
const imgUrl = blok.backgroundImage?.filename
    ? img(blok.backgroundImage?.filename, { format: 'webp' }, { provider: 'storyblok' })
    : null;

const layoutHeaderStyles = computed(() => {
    return {
        '--jp-background-desktop-image': `url('${imgUrl}')`,
        '--jp-background-vertical-offset': blok.backgroundVerticalOffset || '0',
        '--jp-background-mobile-vertical-offset': blok.mobileBackgroundVerticalOffset || '0',
    };
});
</script>

<style lang="postcss" scoped>
:deep(.ui-hero-card-layout-header) {
    @apply px-5 sm:px-0 py-[28px] md:pb-24 lg:pt-20 lg:pb-[88px];
}
</style>
